<template>
  <div class="faults">
    <h2 class="role">MMIS Manager</h2>
  </div>
</template>

<script>
import { fb_db, fs, fb_auth, fb_users } from "../firebase";

export default {
  name: "NewFaults",
  components: {
  
  },
  data() {
    return {
            
    };
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

</style>